const { translateName } = require("../../../utils/i18n");
const _ = require("lodash");

const translate = (object, context) => {
    switch (object.joinedEntity) {
        case "FamilyAxis":
        case "SubStoreAxis":
        case "OrganizationAxis":
            return translateName(object.name, _.get(context, "language.id"));
        case "ProductAxis":
        case "StoreAxis":
            return context.tc && context.tc(object.tKey)
        default:
            return "Invalid joinedEntity";
    }
};

const joinParams = [
    {
        entityName: "StoreAxis",
        childEntityName: "Store"
    },
    {
        entityName: "SubStoreAxis"
    },
    {
        entityName: "ProductAxis",
        childEntityName: "Product"
    },
    {
        entityName: "FamilyAxis",
        childEntityName: "Family"
    },
    {
        entityName: "OrganizationAxis",
        childEntityName: "Organization"
    }
];

export const entity = require("./../../utils/entityJoin").joinEntities({
    name: "AlertAnalyseGroupElement",
    fields: [
        "code",
        "name",
        {
            path: "storeCode",
            f: function() {
                return global.app.S.StoreAxis.objects[0].code;
            }
        },
        {
            path: "childOfAxisEntityName",
            f: function() {
                return joinParams.find(o => o.entityName === this.joinedEntity).childEntityName;
            }
        },
        {
            path: "tName",
            fieldPath: ["name"],
            $f: (object, context, callback) => {
                callback(null, translate(object, context));
            }
        }
    ]
}, joinParams.map(o => o.entityName))
